import React, {useState, useEffect} from 'react';
import './Friend.css';
import Friends from './Friends';
import db from './firebase';
import SearchIcon from '@material-ui/icons/Search';

function Friend({userId, email, findFri}) {

    const [user, setUser] = useState([])
    useEffect(() => {
        db.collection('users').where('email','!=',email).onSnapshot((snapshot) => (
            setUser(snapshot.docs.map((doc) => ({id:doc.id, data:doc.data()}))
        )))
    }, [])
    return (
        <div className="friend">
            <div className="search__bar">
                <input placeholder="Search Friends" />
                <SearchIcon />
            </div>
            {
                user.map((users) => (
                    <Friends 
                    key = {users.id}
                    profile = {users.data.profileImage}
                    name = {users.data.firstName+" "+users.data.lastName}
                    userId = {users.id}
                    email = {users.data.email}
                    findFri = {findFri}
                    />
                ))
            }
        </div>
    )
}

export default Friend
